import { Link } from "react-router-dom";
import { ArrowRight, Loader2 } from "lucide-react";
import Layout from "@/components/layout/Layout";
import { useMall } from "@/context/MallContext";
import { ShopHome } from "@/components/mall/ShopHome";

/**
 * A shop on its own domain (or the pitch page's live demo): the same shop home page the
 * directory shows, with no directory around it.
 */
export default function SoloHome() {
    const { site, demo } = useMall();

    if (!site) {
        return (
            <Layout>
                <div className="flex min-h-[60vh] items-center justify-center" data-testid="solo-loading">
                    <Loader2 className="animate-spin text-zinc-400" />
                </div>
            </Layout>
        );
    }

    return (
        <Layout>
            {!site.standalone && !demo && (
                <div className="border-b border-amber-300 bg-amber-50" data-testid="solo-preview-ribbon">
                    <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-4 gap-y-1.5 px-4 py-2.5 sm:px-6">
                        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-amber-700">
                            Preview · Virtual Brick &amp; Mortar
                        </span>
                        <span className="text-xs text-zinc-700">
                            This is what a Virtual Brick &amp; Mortar looks like: the whole website with one shop in it.
                            It costs ${site.plan?.price_month} a month or ${site.plan?.price_year?.toLocaleString()} a year.
                        </span>
                        <Link to="/whitelabel" data-testid="solo-get-cta"
                            className="ml-auto inline-flex items-center gap-1.5 rounded-full bg-white px-4 py-1.5 font-mono text-[11px] uppercase tracking-[0.16em] text-black transition-transform hover:scale-[1.03]">
                            Get this <ArrowRight size={11} />
                        </Link>
                        <Link to="/site/exit" data-testid="solo-exit-link"
                            className="font-mono text-[11px] uppercase tracking-[0.16em] text-zinc-500 underline hover:text-zinc-900">
                            Back to the directory
                        </Link>
                    </div>
                </div>
            )}
            <ShopHome site={site} />
        </Layout>
    );
}
